import ChapterUserData from 'routes/ChapterAnalytics/ChapterUserData/ChapterUserData';

export default ChapterUserData;
